import type { ExerciseListItem, WorkoutHistoryItem, WorkoutItem } from '../api/types'
import { formatDate } from './format'

export function groupWorkoutsByMonth(workouts: WorkoutHistoryItem[]) {
  const groups = new Map<string, WorkoutHistoryItem[]>()
  workouts.forEach((workout) => {
    const key = workout.localDate.slice(0, 7)
    groups.set(key, [...(groups.get(key) ?? []), workout])
  })
  return [...groups].map(([key, items]) => ({
    key,
    label: formatDate(`${key}-15`, { month: 'long', year: 'numeric' }),
    items,
  }))
}

export function groupExercisesByFamily(items: ExerciseListItem[]) {
  const groups = new Map<string, ExerciseListItem[]>()
  items.forEach((item) => groups.set(item.familyCode, [...(groups.get(item.familyCode) ?? []), item]))
  return [...groups].sort(([left], [right]) => left.localeCompare(right, 'en')).map(([familyCode, exercises]) => ({ familyCode, exercises }))
}

const terminalWorkoutItemStatuses = new Set(['Completed', 'Skipped', 'PainStopped'])

export function orderWorkoutItems(items: WorkoutItem[]) {
  return [...items].sort((left, right) => left.sortOrder - right.sortOrder)
}

export function selectFocusedWorkoutItem(items: WorkoutItem[], selectedItemId?: string | null) {
  const ordered = orderWorkoutItems(items)
  return (
    ordered.find((item) => item.id === selectedItemId)
    ?? ordered.find((item) => !workoutItemProgress(item).terminal)
    ?? ordered[0]
    ?? null
  )
}

export function workoutItemProgress(item: WorkoutItem) {
  const canonicalSlots = item.setPrescriptions?.length ? item.setPrescriptions : null
  const total = canonicalSlots?.length ?? item.prescribedTargets.length
  const completed = canonicalSlots
    ? canonicalSlots.filter((slot) => slot.isConsumed).length
    : Math.min(item.sets.length, total)
  return {
    completed,
    total,
    terminal: terminalWorkoutItemStatuses.has(item.status) || (total > 0 && completed === total),
  }
}
